module.exports = "<img :src=\"src\" :alt=\"alt\" class=\"weui_media_appmsg_thumb\">";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/media/media-appmsg-thumb.vue
 ** module id = 165
 ** module chunks = 0
 **/